import {Record as record} from 'immutable';

export default record(
    {
        byOwnerProperties: [],
        byOwnerPropertiesFetchFailed: false,
        byOwnerPropertiesFetchSuccess: false,
        clientRequestId: '',
        recommendedProperties: [],
        recommendedPropertiesAlternativeTitle: '',
        recommendedPropertiesFetchSuccess: false,
        recommendedPropertiesFetchFailed: false,
        inquiryProperties: [],
        inquiryPropertiesFetchSuccess: false,
        inquiryPropertiesFetchFailed: false,
        propertyContentItems: [],
        registrationNumber: '',
        unitSpaces: {},
        unitContentItems: [],
        unitMetadata: [],
        urgencyMessages: {},
        rankedBadges: [],
        pricingBadges: [],
        superlativeBadges: [],
        geoRelativeDistances: null,
        description: null,
        localizedPropertyDescriptionMap: {},
        vtHelpfulnessHistory: {}
    },
    'listingExtended'
);
